<template>
  <div>
    <Nuevo
      :dialog="dialog"
      @dialog="dialog = $event"
      :Item="itemSelected"
      v-if="dialog"
    />
    <MensajeTransicion
      color="#FA694A"
      :text="mensaje"
      v-if="verAlerta"
      :top="true"
      :bottom="false"
    />

    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header Principal estilo Cliente / Inspección -->
      <v-toolbar
        color="secondary"
        dark
        flat
        class="table-header-toolbar px-2 px-sm-3"
      >
        <div class="d-flex align-center header-main-info flex-grow-1 min-width-0">
          <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
            <v-icon color="white">mdi-account-group</v-icon>
          </div>
          <div class="header-text-block min-width-0 mr-2 mr-sm-3">
            <div class="header-company-title font-weight-bold text-truncate">
              {{ Titulo || "Gestión de Usuarios" }}
            </div>
          </div>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="header-count-chip font-weight-bold elevation-1 flex-shrink-0"
          >
            <v-icon left size="16" color="secondary">mdi-counter</v-icon>
            {{ Items ? Items.length : 0 }} Usuarios
          </v-chip>
        </div>

        <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
          <!-- Botón de Ayuda -->
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1 btn-circle-tooltip"
                icon
                dark
                target="_blank"
                :href="global.helpdesk_url + 'gestion_usuarios'"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="25" color="amber lighten-2"
                  >mdi-help-circle-outline</v-icon
                >
              </v-btn>
            </template>
            <span>¿Necesitas ayuda?</span>
          </v-tooltip>
        </div>
      </v-toolbar>

      <!-- Sección de Filtros y Acciones -->
      <div class="pa-2 pa-sm-4 pb-2">
        <div class="d-flex align-center justify-space-between flex-wrap gap-2 mb-3">
          <!-- Búsqueda General -->
          <div class="search-field flex-grow-1 mr-md-3">
            <v-text-field
              v-model="search"
              outlined
              dense
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              label="Búsqueda rápida"
              placeholder="Buscar por nombre, correo, rol..."
              class="rounded-lg"
            ></v-text-field>
          </div>

          <!-- Botones de Acción -->
          <div class="action-buttons-group d-flex align-center flex-wrap gap-2 mt-2 mt-md-0">
            <!-- Botón Descargar Tabla -->
            <v-btn
              v-if="Excel"
              color="success"
              dark
              height="38"
              class="btn-action-header px-4 font-weight-bold elevation-1 text-none rounded-lg mr-sm-2"
              @click="DescargarExcel()"
            >
              <v-icon left size="18">mdi-file-excel</v-icon>
              Descargar Tabla
            </v-btn>

            <!-- Botón Nuevo Usuario -->
            <v-btn
              v-if="
                global._autorizacion_usuario(Permisos, $route.meta.id, ['2'])
              "
              color="primary"
              dark
              height="38"
              class="btn-action-header px-4 font-weight-bold elevation-1 text-none rounded-lg"
              @click="nuevoItem()"
            >
              <v-icon left size="20">mdi-plus-circle</v-icon>
              Nuevo Usuario
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Indicador de desplazamiento horizontal en celular -->
      <div
        class="d-flex d-sm-none align-center text-caption primary--text mb-2 px-3 pt-1"
      >
        <v-icon x-small color="primary" class="mr-1">
          mdi-gesture-swipe-horizontal
        </v-icon>
        <span>Desliza horizontalmente para ver todos los datos</span>
      </div>

      <!-- Tabla de Datos Principal con Header Oscuro y Chips Estilizados -->
      <div class="table-responsive-wrapper">
        <v-data-table
          dense
          :headers="filteredCabecera"
          :items="Items"
          :items-per-page="10"
          :search="search"
          :mobile-breakpoint="0"
          class="elevation-0 modern-table"
          loading-text="Cargando usuarios... Por favor, espere"
          :loading="Loading"
          no-data-text="No hay usuarios disponibles"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 100],
            'items-per-page-text': 'Resultados por página:',
            'page-text': '{0}-{1} de {2}',
          }"
        >
          <!-- Columna Código / ID -->
          <template v-slot:[`item.id`]="{ item }">
            <span class="font-weight-bold text--secondary font-mono">
              #{{ item.id }}
            </span>
          </template>

          <!-- Columna Rol -->
          <template v-slot:[`item.rol`]="{ item }">
            <v-chip
              x-small
              color="indigo darken-1"
              text-color="white"
              class="font-weight-bold elevation-1 px-3"
            >
              <v-icon left x-small>mdi-shield-account-outline</v-icon>
              {{ item.rol }}
            </v-chip>
          </template>

          <!-- Columna Nombre con Avatar -->
          <template v-slot:[`item.name`]="{ item }">
            <div class="d-flex align-center py-1">
              <v-avatar size="30" color="primary lighten-4" class="mr-2 elevation-1">
                <v-icon small color="primary">mdi-account</v-icon>
              </v-avatar>
              <div>
                <span class="font-weight-bold text--primary d-block">
                  {{ item.name }}
                </span>
                <span
                  v-if="item.telefono"
                  class="text-caption text--secondary font-mono"
                >
                  <v-icon x-small color="grey">mdi-phone</v-icon>
                  {{ item.telefono }}
                </span>
              </div>
            </div>
          </template>

          <!-- Columna Email -->
          <template v-slot:[`item.email`]="{ item }">
            <div class="d-flex align-center font-mono text-caption text--primary">
              <v-icon x-small color="grey darken-1" class="mr-1">mdi-email-outline</v-icon>
              {{ item.email }}
            </div>
          </template>

          <!-- Columna Firma Digital -->
          <template v-slot:[`item.img_firma`]="{ item }">
            <v-chip
              x-small
              :color="item.img_firma ? 'teal lighten-1' : 'grey lighten-2'"
              :text-color="item.img_firma ? 'white' : 'grey darken-2'"
              class="font-weight-medium px-2"
            >
              <v-icon left x-small>
                {{
                  item.img_firma
                    ? 'mdi-draw-pen'
                    : 'mdi-close-circle-outline'
                }}
              </v-icon>
              {{ item.img_firma ? 'Registrada' : 'Sin firma' }}
            </v-chip>
          </template>

          <!-- Columna Fecha -->
          <template v-slot:[`item.fecha`]="{ item }">
            <span class="text-caption font-mono text--secondary" v-if="item.fecha">
              <v-icon x-small color="grey" class="mr-1">mdi-calendar-clock</v-icon>
              {{ item.fecha }}
            </span>
            <span v-else class="text-caption text--disabled">-</span>
          </template>

          <!-- Columna Acciones -->
          <template v-slot:[`item.accion`]="{ item }">
            <div class="d-flex align-center justify-center gap-1">
              <v-tooltip
                bottom
                v-if="
                  global._autorizacion_usuario(Permisos, $route.meta.id, ['3'])
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="26"
                    width="26"
                    color="blue lighten-1"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="editarItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar Usuario</span>
              </v-tooltip>

              <v-tooltip
                bottom
                v-if="
                  global._autorizacion_usuario(Permisos, $route.meta.id, ['4'])
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="action-btn elevation-1 ml-1"
                    height="26"
                    width="26"
                    color="red lighten-1"
                    fab
                    x-small
                    dark
                    @click="eliminar(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Usuario</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import {
    mapActions,
    mapState
} from 'vuex';
import Nuevo from './nuevo.vue'
import exportFromJSON from "export-from-json"
import MensajeTransicion from "../Alerta.vue"
import global from '@/global';

export default {
    props: ["Titulo", "Cabecera", "Items", "Excel", "Crear","Loading"],
    components: {
        Nuevo,
        MensajeTransicion
    },
    data() {
        return {
            search: "",
            dialog: false,
            itemSelected: {},
            mensaje: "",
            verAlerta: false,
            global: global 
        };
    },
    computed: {
        ...mapState("navigation", ["Permisos"]),
        canShowAccionColumn() {
            return (global._autorizacion_usuario(this.Permisos,this.$route.meta.id,['3','4']) );
        },
        filteredCabecera() {
            return this.Cabecera.filter(col => !(col.value === 'accion' && !this.canShowAccionColumn));
        }
    },
    methods: {
        ...mapActions("usuario", ["eliminarUser"]), 

        nuevoItem() {
            console.log("clcik"); 
            this.itemSelected = {
                id: 0,
                nombre: '',
                apellidos: '',
                telefono: '',
                selectedRoles: '',
                selectedEmpresa: [],
                imagen_firma: '',
                imagen: '',
                email: '',
                pasword: ''
            }
            this.dialog = true; 
        },

        eliminar(item) {  
            this.$alertify.confirm(
                `¿Desea eliminar permanentemente al usuario: ${item.nombre} ${item.apellidos}?`,
                () => {
                    this.eliminarUser(item)
                        .then(r => {
                            this.$alertify.success(`Usuario ${item.nombre} ${item.apellidos} (ID: ${item.id}) eliminado correctamente.`);
                        })
                        .catch(error => {
                            console.log(error)
                        });
                },
                () => this.$alertify.error("Se cancelo la acción")
            ).setHeader('<h3 class="alertTitle">Eliminar Usuario</h3'); 
        },

        editarItem(item) {
            this.itemSelected = item;
            this.dialog = true;
        },

        DescargarExcel() {
            const data = this.Items;
            const nombreArchivo = 'usuarios';
            const exportType = exportFromJSON.types.xls; //xls, json, css, html,txt 
            exportFromJSON({
                data,
                nombreArchivo,
                exportType
            })
        }
    }
};
</script>

<style scoped>
.min-width-0 {
  min-width: 0;
}

.table-header-toolbar {
  min-height: 58px;
}

.header-main-info {
  overflow: hidden;
}

.header-icon-box {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-company-title {
  font-size: 1.08rem;
  letter-spacing: -0.2px;
}

.header-count-chip {
  font-size: 0.85rem;
  height: 28px;
}

.modern-table {
  border-top: 1px solid #e2e8f0;
}

.modern-table ::v-deep table {
  min-width: 850px;
  width: 100%;
}

.modern-table ::v-deep thead th:first-child,
.modern-table ::v-deep tbody tr td:first-child {
  position: sticky !important;
  left: 0 !important;
  background-color: #ffffff !important;
  z-index: 2 !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.modern-table ::v-deep thead th:first-child {
  background-color: #424242 !important;
  z-index: 3 !important;
}

.modern-table ::v-deep tbody tr:hover td:first-child {
  background-color: #f8fafc !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  white-space: nowrap;
  height: 42px !important;
}

.modern-table
  ::v-deep
  thead
  tr:not(.v-data-table__progress)
  th
  .v-data-table-header__icon {
  color: #ffffff !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th span {
  color: #ffffff !important;
}

.modern-table ::v-deep .v-data-table__progress th {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep .v-data-table__empty-wrapper td {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 8px 14px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
  transition: background-color 0.15s ease-in-out;
}

.modern-table ::v-deep .v-data-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.82rem;
  padding: 8px 16px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out !important;
}

.action-btn:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.gap-1 {
  gap: 6px;
}

.gap-2 {
  gap: 8px;
}

.font-mono {
  font-family: monospace, "Courier New", Courier;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.88rem !important;
    line-height: 1.2;
  }

  .header-count-chip {
    font-size: 0.75rem !important;
    height: 24px !important;
    padding: 0 6px !important;
  }

  .header-count-chip .v-icon {
    font-size: 14px !important;
    margin-right: 2px !important;
  }

  .search-field {
    width: 100% !important;
    max-width: 100% !important;
    margin-right: 0 !important;
  }

  .action-buttons-group {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 8px !important;
  }

  .btn-action-header {
    width: 100% !important;
    max-width: 100% !important;
    justify-content: center !important;
    margin: 0 !important;
  }

  .modern-table ::v-deep thead th {
    font-size: 0.72rem !important;
    padding: 8px 10px !important;
    height: 38px !important;
  }

  .modern-table ::v-deep td {
    font-size: 0.78rem !important;
    padding: 6px 10px !important;
  }

  .modern-table ::v-deep .v-data-footer {
    flex-wrap: wrap;
    justify-content: center;
    padding: 8px 6px;
    gap: 6px;
  }

  .modern-table ::v-deep .v-data-footer__select {
    margin-right: 6px;
  }

  .modern-table ::v-deep .v-data-footer__pagination {
    margin: 0 4px;
  }
}
</style>

